

class VideoContainer extends HTMLElement {
    constructor() {
        super();
        if(this.getAttribute('data-has-video') != "false") {
          this.listeners();
        }


    }

    listeners() {
      var self = this;
      //video trigger
      var videoTrigger = this.querySelector('[data-video-trigger]');

      // Trigger skin health PDP video to open on scroll
      if (this.classList.contains('skin-health__video-container') && this.dataset.autoPlay == 'true') {
        var videoObserver = new IntersectionObserver(function(videos) {
          if(videos[0].isIntersecting === true){
            console.log('play');
            self.openVideo();
          }
        }, { threshold: [0.25] });
        videoObserver.observe(videoTrigger);
      }

      videoTrigger.addEventListener('click', function(event){
        console.log('click on video image');
        self.openVideo();
      });

      //video finished
      this.querySelector('[data-video]').addEventListener('ended', function() {
        self.closeVideo();
      });
      //video close button
      var videoCloseButton = this.querySelector('[data-video-close]');
      if(videoCloseButton != null) {
        videoCloseButton.addEventListener('click', function() {
          self.closeVideo();
        });
      }
    }

    openVideo() {
      this.classList.add('is--active');
      if (this.classList.contains('skin-health__video-container')) {
        // Need to mute the video to allow autoplay
        this.querySelector('[data-video]').muted = true;
      }
      this.querySelector('[data-video]').play();
    }

    closeVideo() {
      this.classList.remove('is--active');
      this.querySelector('[data-video]').pause();
      // document.exitFullscreen();
    }

}

customElements.define('video-container', VideoContainer);
